import { buildCommonEditorActionTypes } from "./commonEditorATBuider";
import { buildCommonGridActionTypes } from "./commonGridATBuilder";

export const MEMBERS_GRID = buildCommonGridActionTypes("MEMBERS");

export const MEMBER_EDITOR = {
    ...buildCommonEditorActionTypes("MEMBER"),
    CONTRACT: "CONTRACT_MEMBER",
};
